import { State } from "@/services/backend/deliveries/state/state";
import { cn } from "@/shared/lib/utils";

export const deliveryStateLabel: { [key: string]: string } = {
  [State.Announced]: "Angekündigt",
  [State.Delivered]: "Angekommen",
};

export function DeliveryStateLabel({ status }: { status: string }) {
  return <span className={cn("flex")}> {deliveryStateLabel[status]} </span>;
}
